import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="max-w-3xl mx-auto px-6 lg:px-10 py-32 text-center">
      <div className="font-mono text-[10px] tracking-widest uppercase text-ink-muted mb-4">
        404
      </div>
      <h1 className="font-display font-bold tracking-tighter text-5xl md:text-7xl text-ink mb-6">
        Off the map.
      </h1>
      <p className="text-ink-muted mb-8">That page doesn&apos;t exist — or doesn&apos;t exist yet.</p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 bg-ink text-cream px-6 py-3 text-sm font-medium hover:bg-ember transition-colors"
      >
        Back to home
      </Link>
    </div>
  );
}
